import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userEntitlementsStateSelector} from './user-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const userEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('userEntitlements');

export const userEntitlementsActions = userEntitlementsSlice.actions;
const userEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.userPage.tabs.userEntitlements.assigned.entitlements.cache;
export const userEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.userPage.tabs.userEntitlements.assigned.entitlements;
export const userEntitlementsResultSelector = getCachedTableResultSelector(
    userEntitlementsCacheSelector,
    userEntitlementsStateSelector,
);
